import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {TombOfNefertitiGameShaker} from "../../gameshake/TombOfNefertitiGameShaker";
import {TombOfNefertitiFreeSpinIntroView} from "../../screen/freespinintro/TombOfNefertitiFreeSpinIntroView";
import {TombOfNefertitiParsedGameData} from "../../server/data/TombOfNefertitiParsedGameData";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";
import {TombOfNefertitiReelController} from "../reel/TombOfNefertitiReelController";

export class TombOfNefertitiScatterAttentionView extends BaseView {

    private fireAnimList:{ [index:number]:{ anim:TimelineSprite | null, innerAnim:TimelineSprite | null } } = {};
    private landingAnimList:{ [index:number]:{ anim:TimelineSprite | null } } = {};
    private _gameConfigInstance:TombOfNefertitiGameConfig = TombOfNefertitiGameConfig.instance;
    private fireAnimationContainer:PIXI.Container;
    private landingAnimationContainer:PIXI.Container;
    private dimmingAnimationContainer:PIXI.Container;
    private fsAwardAnimationContainer:PIXI.Container;
    private anticipatingIndex:number = 0;
    private anticipatingPositions:number[] = [];
    private _currentAnimTimeLine:Timeline | null;
    private _freespinText:string = '';
    private _fsAwardedText:PIXI.Text = new PIXI.Text("");
    private _blastAnim:TimelineSprite;
    private _fsAwardedMsgTL:TimelineLite;
    private _gameMode:string = '';
    private _isSpecialFeatureAvailable:boolean;
    private currentLandingReelId:number;

    private _scatterCount:number = 0;

    get scatterCount():number {
        return this._scatterCount;
    }

    public updateAnticipatingPositions(indexes:number[]):void {
        this.anticipatingIndex = 0;
        this.anticipatingPositions = indexes;
        //this.makeSymbolsVisible(true);
    }

    public makeSymbolsVisible(visibility:boolean):void {
        for(let reelId:number = 0; reelId < 15; reelId++) {
            let reel:ReelController | null = Reels.getReel(reelId);

            if(!visibility && ((reel!.view.children[2] as PIXI.Sprite).children[1] as PIXI.Sprite)) {
                ((reel!.view.children[2] as PIXI.Sprite).children[1] as PIXI.Sprite).tint = 0xFFFFFF;
            }
        }
    }

    public addLandingAnimationToReel(reelId:number):void {
        let reel:TombOfNefertitiReelController | null = <TombOfNefertitiReelController>Reels.getReel(reelId);
        let reelPosition:number[] = Helper.getSymbolPositions(reelId, 0);

        (reel!.view.children[2] as StateReelSymbol).visible = false;
        if(!(this.landingAnimList[reelId])) {
            this.landingAnimList[reelId] = {anim : null};
        }

        let anim = this.landingAnimList[reelId]['anim'] = new TimelineSprite(GameResources.getTextures('bonusLandingAnim'));
        anim.anchor.set(0.5);
        anim!.position.set(reelPosition[0], reelPosition[1] - (this._gameConfigInstance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - this._gameConfigInstance.SYMBOL_HEIGHT) / 2);

        this.landingAnimationContainer.addChild(anim);
        this.sortLandingAnimation();
        this._scatterCount++;

        if(this._gameMode.indexOf(GameMode.FREESPIN) !== -1) {
            this.addFSIncrementAnimation(reelPosition);
            SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.SCATTER_LANDING_FS);
        } else {
            if(!reel.isQuickStop()) {
                this.addBlastAnimation(true);
            }

            if(this._scatterCount === 1) {
                SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.SCATTER_LANDING_COUNT_1);
            } else {
                SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.SCATTER_LANDING);
            }
        }

        if(this.minScatterFound()) {
            this.playAllLandingAnimation();
        } else {
            anim.getAnimation();
        }

        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.START_GAME_SHAKING_REEL_AREA));
        TweenLite.to(() => {}, 0.3, {
            onComplete : () => {
                EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.STOP_GAME_SHAKING));
            }
        });
    }

    public playScatterAnimation():void {
        EventHandler.dispatchEvent(new GameEvent("FORCE_HIDE_TOTAL_WIN"));

        for(let i in this.landingAnimList) {
            (this.landingAnimList[i]['anim'] as any)._textures = GameResources.getTextures('bonusAnim');
            (this.landingAnimList[i]['anim'] as TimelineSprite).getAnimation();
            TweenLite.to(this.landingAnimList[i]['anim']!.scale, 0.5, {x : 1.2, y : 1.2});
        }

        setTimeout(() => {
            this.stopAllReelLandingAnimation();
            this.stopAllReelAttention();
            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiFreeSpinIntroView.FREESPIN_INTRO_TRANSITION_IN, 'IN'));
            if(this._scatterCount > 2) {
                // the delay time is the time for the presentation of entering the tomb(taken from fadeReels method) in TombOfNefertitiBackground class
                TweenLite.delayedCall(1.4, () => this.addBlastAnimation(false));
            }
        }, 1000 + this._blastAnim.totalDuration + 0.2);
    }

    private fadeReelSymbol(reelId:number):void {
        let reel:TombOfNefertitiReelController | null = <TombOfNefertitiReelController>Reels.getReel(reelId);

        if(reel!.stopReelSet[0] !== "W") {
            ((reel!.view.children[2] as PIXI.Sprite).children[1] as PIXI.Sprite).tint = 0x555555;
        }
    }

    public addAttentionToReels(reels:number[]):void {
        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.START_GAME_SHAKING_SCATTER_ATTENTION));
        for(let i = 0; i < reels[0]; i++) {
            this.fadeReelSymbol(i);
        }
        for(let i = 0; i < reels.length; i++) {
            this.addAttentionToReel(reels[i]);
        }
    }

    public addAttentionToReel(reelId:number):void {
        if(!(this.fireAnimList[reelId])) {
            this.fireAnimList[reelId] = {anim : null, innerAnim : null};
        }

        if(this.fireAnimList[reelId]['anim']) {
            return;
        }

        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.ANTICIPATION_PER_TILE);
        this.currentLandingReelId = reelId;
        this.onCompleteCallback(reelId);
    }

    public stopReelAttention(reelId:number, keepTint:boolean = false):void {
        if(!this.fireAnimList[reelId]) {
            return;
        }

        let currentAnim:TimelineSprite = (this.fireAnimList[reelId].anim as TimelineSprite);
        let currentInnerAnim:TimelineSprite = (this.fireAnimList[reelId].innerAnim as TimelineSprite);
        currentAnim.stopLoop();
        currentInnerAnim.stopLoop();
        currentAnim.parent.removeChild(currentAnim);
        currentInnerAnim.parent.removeChild(currentInnerAnim);
        currentAnim.destroy();
        currentInnerAnim.destroy();
        delete this.fireAnimList[reelId];

        if(!keepTint) {
            this.fadeReelSymbol(reelId);
        }
    }

    public stopLandingAnimation(reelId:number):void {
        if(!this.landingAnimList[reelId]) {
            return;
        }

        let reel:ReelController | null = Reels.getReel(reelId);
        (reel!.view.children[2] as StateReelSymbol).visible = true;

        let currentAnim:TimelineSprite = (this.landingAnimList[reelId].anim as TimelineSprite);
        currentAnim.stopLoop();
        currentAnim.parent.removeChild(currentAnim);
        currentAnim.destroy();
        delete this.landingAnimList[reelId];
    }

    public stopAllReelAttention():void {
        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.STOP_ATTENTION_SHAKING));
        this.makeSymbolsVisible(false);
        this.anticipatingIndex = (this.anticipatingPositions.length - 1);
        if(this._currentAnimTimeLine) {
            this._currentAnimTimeLine.kill();
            this._currentAnimTimeLine = null;
        }
        for(let index in this.fireAnimList) {
            let currentAnim:TimelineSprite = (this.fireAnimList[index].anim as TimelineSprite);
            let currentInnerAnim:TimelineSprite = (this.fireAnimList[index].innerAnim as TimelineSprite);
            currentAnim.stopLoop();
            currentInnerAnim.stopLoop();
            currentAnim.parent.removeChild(currentAnim);
            currentInnerAnim.parent.removeChild(currentInnerAnim);
            currentAnim.destroy();
            currentInnerAnim.destroy();
            delete this.fireAnimList[index];
        }
    }

    public stopAllReelLandingAnimation():void {
        for(let index in this.landingAnimList) {
            if(this.landingAnimList[parseInt(index)]['anim']!.scale.x > 1) {
                this.fadeScatterAnim();
                break;
            }
            this.stopLandingAnimation(parseInt(index));
        }
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data:TombOfNefertitiParsedGameData):void {
        this._gameMode = data.mode;

        if(this._gameMode === GameMode.NORMAL || this._gameMode === GameMode.FREESPIN) {
            this._scatterCount = 0;
        }

        if(this._gameMode === GameMode.FREESPIN) {
            this._isSpecialFeatureAvailable = data.isCurseFeatureTriggered || data.isCurseFeatureReSpinTriggered || data.isWildRaidFeatureTriggered;
        } else {
            this._isSpecialFeatureAvailable = false;
        }
    }

    protected initAnimations():void {
        this.fireAnimationContainer = new PIXI.Container();
        this.dimmingAnimationContainer = new PIXI.Container();
        this.landingAnimationContainer = new PIXI.Container();
        this.fsAwardAnimationContainer = new PIXI.Container();

        let animationLayer:PIXI.Container = StageManager.getLayer(this._gameConfigInstance.LAYERS.ATTENTION_LAYER.name);
        animationLayer.addChild(this.fireAnimationContainer);
        animationLayer.addChild(this.dimmingAnimationContainer);
        animationLayer.addChild(this.landingAnimationContainer);
        StageManager.getLayer(this._gameConfigInstance.LAYERS.FS_AWARD.name).addChild(this.fsAwardAnimationContainer);

        this._freespinText = Translation.translate("RAIDER SPINS");

        const textStyle:TextStyleOptions = {
                fill : ["#fbbd16", "#fff47b", "#fbbd16"],
                fillGradientStops : [0.1, 0.5, 0.9],
                fillGradientType : 0,
                fontSize : 80,
                fontFamily : TombOfNefertitiGameConfig.instance.USABLE_FONT,
                dropShadow : true,
                dropShadowAlpha : 1,
                dropShadowAngle : 90,
                dropShadowBlur : 6,
                dropShadowColor : "#250e08",
                dropShadowDistance : 5,
                padding : 8,
                stroke : "#4a1703",
                strokeThickness : 4
            },
            stageCenter:number[] = Helper.getSymbolPositions(Math.floor(TombOfNefertitiGameConfig.instance.REELS_NUM / 2), 0);
        this._blastAnim = new TimelineSprite(GameResources.getTextures('explode'));
        this._blastAnim.visible = false;
        this._blastAnim.scale.set(4);
        this._blastAnim.anchor.set(0.5);
        this._blastAnim.position.set(stageCenter[0], stageCenter[1]);
        this.fsAwardAnimationContainer.addChild(this._blastAnim);

        this._fsAwardedText = new PIXI.Text('', textStyle);
        this._fsAwardedText.alpha = 0;
        this._fsAwardedText.anchor.set(0.5);
        this._fsAwardedText.position.set(stageCenter[0], stageCenter[1]);
        this.fsAwardAnimationContainer.addChild(this._fsAwardedText);
    }

    private generateTextString(message:string):PIXI.Text {
        const textStyle:TextStyleOptions = {
            fill : ["#fbbd16", "#fff47b", "#fbbd16"],
            fillGradientStops : [0.1, 0.5, 0.9],
            fillGradientType : 0,
            fontSize : 100,
            fontFamily : TombOfNefertitiGameConfig.instance.USABLE_FONT,
            dropShadow : true,
            dropShadowAlpha : 1,
            dropShadowAngle : 90,
            dropShadowBlur : 6,
            dropShadowColor : "#250e08",
            dropShadowDistance : 5,
            padding : 8,
            stroke : "#4a1703",
            strokeThickness : 4
        };

        let bitmapText = new PIXI.Text('', textStyle);
        bitmapText.text = message;
        bitmapText.anchor.set(0.5);
        this.fsAwardAnimationContainer.addChild(bitmapText);
        return bitmapText;
    }

    private addFSIncrementAnimation(position:number[]):void {
        let counter:PIXI.Text = this.generateTextString("+1");
        counter.position.set(position[0], position[1]);

        // Cannot abort while freespin.
        TweenLite.to(counter, 0.7, {
            y : position[1] - 100,
            delay : 0.5,
            onStart : () => {
                SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.FS_ADDITIONAL_SCATTER_AWARD);
            },
            onComplete : () => {
                counter.parent.removeChild(counter);
                counter.destroy();
            }
        });
        TweenLite.to(counter, 0.3, {alpha : 0, delay : 0.8});
    }

    private addBlastAnimation(isNormal:boolean):void {
        let minScatterCount:number = 3;
        let winMessage:string = (this._scatterCount - 1) * 5 + " " + this._freespinText;

        if(this._scatterCount < minScatterCount) {
            return;
        }

        if(this._fsAwardedText.alpha > 0) {
            this._fsAwardedMsgTL.kill();
            this._fsAwardedText.alpha = 0;
        }

        let animDuration = this._blastAnim.totalDuration;
        this._blastAnim.getAnimationAutoShowHide(true, true);
        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.SCATTER_LANDING_COUNT_3);

        this._fsAwardedText.text = winMessage;

        this._fsAwardedMsgTL = new TimelineLite();
        this._fsAwardedMsgTL.add(() => {
            TweenLite.to(this._fsAwardedText, animDuration / 4, {alpha : 1});
        });

        this._fsAwardedMsgTL.add(() => {
            TweenLite.to(this._fsAwardedText, animDuration / 4, {alpha : 0});
        }, isNormal ? animDuration / 2 : 1.4 + animDuration / 2); // the time 1.4 is the time for the presentation of entering the tomb(taken from fadeReels method) in TombOfNefertitiBackground class
    }

    private minScatterFound():boolean {
        let minScatter:boolean = false;
        for(let i in this.landingAnimList) {
            if(minScatter) {
                return true;
            }
            minScatter = true;
        }
        return false;
    }

    private onCompleteCallback(id:number):void {
        let reelPosition:number[] = Helper.getSymbolPositions(id, 0);
        let currentAnim = new TimelineSprite(GameResources.getTextures('fireLoopGreyScale'));
        let currentAnimInnerWhite = new TimelineSprite(GameResources.getTextures('fireLoopInnerWhite'));
        this.fireAnimList[id] = {anim : null, innerAnim : null};
        this.fireAnimList[id]['anim'] = currentAnim;
        currentAnim.tint = 0x4E0F96;  //0xFAB832; // Yellow,    0xBE30F5 => Magenta
        this.fireAnimList[id]['innerAnim'] = currentAnimInnerWhite;
        currentAnim.blendMode = PIXI.BLEND_MODES.ADD;
        currentAnimInnerWhite.blendMode = PIXI.BLEND_MODES.ADD;
        this.fireAnimList[id]['anim']!.anchor.set(0.5);
        currentAnimInnerWhite.anchor.set(0.5);
        currentAnim.position.set(reelPosition[0], reelPosition[1]);
        currentAnimInnerWhite.position.set(reelPosition[0], reelPosition[1]);
        this.fireAnimationContainer.addChild(currentAnimInnerWhite);
        this.fireAnimationContainer.addChild(currentAnim);
        currentAnim.playLoop();
        currentAnimInnerWhite.playLoop();
    }

    private playAllLandingAnimation():void {
        for(let i in this.landingAnimList) {
            (this.landingAnimList[i]['anim'] as TimelineSprite).playLoop();
        }
    }

    private updateScatterTexture(index:number):void {
        let reel:ReelController | null = Reels.getReel(index);
        ((reel!.view.children[2] as StateReelSymbol).children[0] as PIXI.Sprite).texture = GameResources.getTextures("Bonus animation/B01_00013")[0];
    }

    private sortLandingAnimation():void {
        for(let i = 1; i <= 2; i++) {
            for(let j = 0; j < 5; j++) {
                let landingAnimationObj = this.landingAnimList[3 * j + i];
                if(landingAnimationObj) {
                    landingAnimationObj['anim']!.parent.addChild(landingAnimationObj['anim']!);
                }
            }
        }
    }

    private fadeScatterAnim():void {
        for(let index in this.landingAnimList) {
            TweenLite.to(this.landingAnimList[parseInt(index)]['anim'], 1, {
                alpha : 0, onComplete : () => {
                    this.stopLandingAnimation(parseInt(index))
                }
            });
        }
    }
}